import { QRCodeCanvas } from "qrcode.react"
import { useCallback, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useApi } from "../../../api"
import { ICargo, IWallet } from "../../../interfaces"
import { Utils } from "../../../utils"
import { Loader } from "../../Loader"
import { Numeral } from "../../Numeral"

export const WalletSlideUpUsdt = () => {
  const { t } = useTranslation()
  const api = useApi('NFT')

  const [isMounted, setMounted] = useState(false)
  const [wallet, setWallet] = useState<IWallet>()
  const [transactions, setTransactions] = useState([])
  const [walletAddress, setWallerAddress] = useState('')

  const fetchWallet = useCallback(() => {
    if (!Utils().isLogin()) return;
    api.getWallet('USDT', (cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        if (cargo.info.length > 0) {
          setWallet(cargo.info[0])
          setWallerAddress(cargo.info[0].address)
        }
      }
    });
  }, [api])

  const fetchTransactions = useCallback(() => {
    if (!Utils().isLogin()) return;
    api.getUsdtTransactions((cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        setTransactions(cargo.info)
      }
    });
  }, [api])

  useEffect(() => {
    if (!isMounted) {
      fetchWallet()
      fetchTransactions()
    }
    setMounted(true)
  }, [fetchWallet, fetchTransactions, isMounted])

  return (
    <>
      <div className="cardd2 px-sm-5 py-sm-4 p-3">
        <div className="d-flex justify-between text-left">
          <div>
            <div className="w-10"><img src={require("../../../assets/img/nft/Tether-USDT-icon.png")} alt="USDT logo" /></div>
            <div className="text-xs mt-3">{t('usdt')}</div>
            <h4 className="font-weight-bold">
              {!wallet ? <Loader /> : <Numeral value={wallet.balance} />}
            </h4>
          </div>
          <div>
            <div>
              {wallet && <QRCodeCanvas
                value={wallet.address}
                fgColor="#495057"
                size={90}
              />}
            </div>
          </div>
        </div>
        <div className="text-left text-sm">{t('usdtAddress')}</div>
        <div className="text-center text-xs text-gray-500 text-ellipsis overflow-hidden">
          {!wallet ? '' : <div>{wallet.address}</div>}
        </div>
        <hr />
        {
          transactions && transactions.map((trx: any, index) => {
            let sign = '';
            if (trx['from'] === walletAddress) {
              sign = '-'
            } else if (trx['to'] === walletAddress) {
              sign = '+'
            }
            return (
              <div key={index}>
                <div className="text-xs d-flex justify-between">
                  <div>{`${new Intl.DateTimeFormat('ko-KR').format(new Date(trx['timeStamp'] * 1000))}`}</div>
                  <div className="text-right">{sign} <Numeral value={trx['value'] * 0.000000000000000001} /></div>
                </div>
              </div>
            )
          })
        }
        <hr />
        <div className="text-sm"><a href={`https://tronscan.org/#/address/${walletAddress}`}>More...</a></div>
      </div>
    </>
  )
}